export default "__VITE_ASSET__42cb3cc0__"